$(function () {
    $(".voucher-summary .summary-line[data-target]").each(function () {
        console.log(this);
        $(`#${$(this).data("target")}`).on("input", function () {
            window[`parse_summary_${$(this).attr("id")}`]($(this).val());
        });
    });
});
